import PropTypes from 'prop-types';

const AccordionSection = ({ title, icon, isOpen, onToggle, children }) => (
  <section className={`accordion-section ${isOpen ? 'open' : ''}`}>
    <button
      type="button"
      className="accordion-trigger"
      onClick={onToggle}
      aria-expanded={isOpen}
    >
      <span>
        <i className={`bi ${icon}`} />
        {title}
      </span>
      <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'}`} />
    </button>
    {isOpen && <div className="accordion-content">{children}</div>}
  </section>
);

AccordionSection.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};
export default AccordionSection;
